import "./brainsbehind.css";

const cards = [
  {
    imgSrc: "/images/shobhit.svg",
    name: "Shobhit Goyal",
    designation: "Founder & CEO",
    linkedinUrl: "https://www.linkedin.com/in/shobhitgoyal07",
    desc:
      "Shobhit Goyal is the co-founder of BeFiSc, a platform built for teams who know trust goes beyond credit scores. By combining identity, behavior, email, and context, BeFiSc gives businesses a sharper, more human view of risk. Before this, Shobhit led growth at Invoid and Bureau. Years in the field taught him that risk is rarely clean or obvious. BeFiSc was built to handle that chaos—quietly, intelligently, and API-first.",
  },
  {
    imgSrc: "/images/abinash.svg",
    name: "Abinash Kumar",
    designation: "CTO & Co-Founder",
    linkedinUrl: "https://www.linkedin.com/in/abinash-kumar-0707",
    desc:
      "Abinash Kumar co-founded BeFiSc to build verification systems that are quick to run, easy to understand, and built on trust. Across his earlier ventures, he saw how identity checks, document integrity, and risk signals were handled separately, forcing teams to piece things together on their own. That shaped his approach: bring the signals into one place and make them clear from the start, focusing on turning identity and document checks into reliable, straightforward workflows.",
  },
];

const BrainsBehind = () => {
  return (
    <div className="brains-main">
      <span className="brains-head">
        Brains Behind <span className="brains-head-1">BeFiSc</span>
      </span>

      <div className="cards-main-section">
        {cards?.map((card, idx) => {
          return (
            <div className="card-1">
              <img
                src={card?.imgSrc}
                alt={card?.name}
                loading="lazy"
                decoding="async"
              />

              <div className="designation-linkedin">
                <div className="name-designation">
                  <span className="card-name">{card?.name}</span>
                  <span className="card-designation">{card?.designation}</span>
                </div>

                <a
                  href={card?.linkedinUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="/images/blue-linkedin.svg"
                    alt="blue-linkedin"
                    loading="lazy"
                  />
                </a>
              </div>

              {/* description */}
              <span className="card-description">{card?.desc}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BrainsBehind;
